<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="The"><span href="#/xhtml/contents#c_The" title="Link target outside of Sample">THE WOLF MOON</span></p>
<p class="tni">The Farmers’ Almanac derives the names of the months from the Native Americans of what is now the north-eastern United States.</p>
<p class="tx">The Wolf Moon is the Moon of January, the moon when the wolves howl in hunger and want; the moon of deepest cold and darkness.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fmtext1.vue?ba8c9a04